import React, { useState, useRef, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { FaRupeeSign } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import { CloudCog } from "lucide-react";

const FinanialStatmentStandlone = ({ isSubScribe, apiData }) => {
  const [currency, setCurrency] = useState("Crore");
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [financialYears, setfinancialYears] = useState([]);
  const [isStandaloneOpen, setIsStandaloneOpen] = useState(true);
  const [isStandaltwoOpen, setIsStandaltwoOpen] = useState(true);
  const [isStandalthreeOpen, setIsStandalthreeOpen] = useState(true);
  const [isStandalfourOpen, setIsStandalfourOpen] = useState(true);
  const [isStandalfiveOpen, setIsStandalfiveOpen] = useState(true);
  const [referenceDocsForSelectedYear, setReferenceDocsForSelectedYear] =
    useState(null);

  const tableRef1 = useRef();
  const tableRef2 = useRef();
  const tableRef3 = useRef();
  const tableRef4 = useRef();
  const tableRef5 = useRef();

  const toggleStandalone = () => {
    setIsStandaloneOpen((prev) => !prev);
  };

  const toggleStandaltwo = () => {
    setIsStandaltwoOpen((prev) => !prev);
  };

  const toggleStandalthree = () => {
    setIsStandalthreeOpen((prev) => !prev);
  };

  const toggleStandalfour = () => {
    setIsStandalfourOpen((prev) => !prev);
  };

  const toggleStandalfive = () => {
    setIsStandalfiveOpen((prev) => !prev);
  };

  const hasData =
    apiData &&
    apiData.length > 0 &&
    apiData.some((item) => item?.FinancialData?.length > 0);

  useEffect(() => {
    let data = [
      ...new Set(
        apiData?.flatMap((item) =>
          item?.FinancialData?.map((fine) => fine.financialYear)
        )
      ),
    ];

    data = data.sort((a, b) => parseInt(b) - parseInt(a));
    setfinancialYears(data);
    // Set default selected range to previous year - current year (financial year)
    setSelectedDateRange(`${parseInt(data[0]) - 1} - ${data[0]}`);
  }, [apiData]);

  useEffect(() => {
    if (selectedDateRange) {
      const selectedYears = selectedDateRange.split(" - ");
      const docs =
        apiData
          .flatMap((item) =>
            item?.FinancialData?.filter((data) =>
              selectedYears.includes(data.financialYear)
            )
          )
          .map((data) => data?.referenceDocuments) || [];

      setReferenceDocsForSelectedYear(docs.find((doc) => doc) || null);
    }
  }, [selectedDateRange, apiData]);

  // Sorting and filtering data based on the selected year range
  const filteredData = selectedDateRange
    ? apiData
      .flatMap((item) =>
        item?.FinancialData?.filter((data) =>
          selectedDateRange.split(" - ").includes(data.financialYear)
        )
      )
      .sort((a, b) => {
        const yearA = parseInt(a.financialYear);
        const yearB = parseInt(b.financialYear);
        return yearA - yearB; // Ascending order of financial year
      })
    : [];

  const BalanceSheet = [
    {
      title: "Equity and Liabilities",
      subcategories: [
        {
          subtitle: "Equity",
          items: [
            { name: "Share Capital", key: "equity_share_capital" },
            {
              name: "Reserves and supplies",
              key: "equity_reserves_and_supplies",
            },
            { name: "Other Equity", key: "equity_other_equities" },
            { name: "Total Equity", key: "total_equity" },
          ],
        },
      ],
    },
    {
      title: "Liabilities",
      subcategories: [
        {
          subtitle: "Non-current Liabilities",
          items: [
            {
              name: "Long Term Borrowings",
              key: "liabilities_longterm_borrowings",
            },
            {
              name: "Net Deferred Tax Liabilities",
              key: "liabilities_net_deferred_tax_liabilities",
            },
            {
              name: "Other Long Term Liabilities",
              key: "liabilities_other_longterm",
            },
            {
              name: "Long Term Provision",
              key: "liabilities_longterm_provisions",
            },
            {
              name: "Total Non-current Liabilities",
              key: "liabilities_total_noncurrent",
            },
          ],
        },
        {
          subtitle: "Current Liabilities",
          items: [
            {
              name: "Short Term Borrowings",
              key: "liabilities_shortterm_borrowings",
            },
            { name: "Trade Payables", key: "liabilities_trade_payables" },
            {
              name: "Other Current Liabilities",
              key: "liabilities_other_current",
            },
            { name: "Short Term Provisions", key: "liabilities_total_current" },
            {
              name: "Total Current Liabilities",
              key: "liabilities_total_current",
            },
          ],
        },
        {
          subtitle: "Total Equity and Liabilities",
          items: [
            {
              name: "Total Equity and Liabilities",
              key: "total_equity_liabilities",
            },
          ],
        },
      ],
    },
    {
      title: "Assets",
      subcategories: [
        {
          subtitle: "Net Fixed Assets",
          items: [
            { name: "Tangible Assets", key: "assets_tangible" },
            { name: "Intangible Assets", key: "assets_intangible" },
            { name: "Total Net Fixed Assets", key: "assets_totalNetAssets" },
            {
              name: "Capital Work-in-progress",
              key: "assets_capital-inProgress",
            },
          ],
        },
        {
          subtitle: "Other Non-current Assets",
          items: [
            {
              name: "Non-current Investments",
              key: "assets_non_current_investments",
            },
            { name: "Net Deferred Tax Assets", key: "assets_net_deferred_tax" },
            {
              name: "Long Term Loans and Advances",
              key: "assets_longtermloans_advances",
            },
            {
              name: "Other Non-current Assets",
              key: "assets_other_non_current",
            },
            {
              name: "Total Other Non-current Assets",
              key: "assets_total_noncurrent",
            },
          ],
        },
        {
          subtitle: "Current Assets",
          items: [
            { name: "Current Investments", key: "assets_currentInvestments" },
            { name: "Inventories", key: "assets_inventories" },
            { name: "Trade Receivables", key: "assets_trade_receivables" },
            {
              name: "Cash and Bank Balances",
              key: "assets_cash_and_bankbalance",
            },
            {
              name: "Short Term Loans and Advances",
              key: "assets_shorttermloans_advances",
            },
            { name: "Other Current Assets", key: "assets_otherCurrent" },
            { name: "Total Current Assets", key: "totalCurrentAssets" },
          ],
        },
        {
          subtitle: "Total Assets",
          items: [{ name: "Total Assets", key: "totalAssets" }],
        },
      ],
    },
  ];

  const sections = [
    {
      title: "Net Revenue",
      subcategories: [
        {
          items: [{ name: "Net Revenue", key: "netRevenue" }],
        },
      ],
    },
    {
      title: "Operating Cost",
      subcategories: [
        {
          items: [
            {
              name: "Cost of Materials Consumed",
              key: "cost_of_materialsConsumed",
            },
            {
              name: "Purchases of Stock-in-trade",
              key: "purchases_of_stockTrades",
            },
            {
              name: "Changes in Inventories / Finished Goods",
              key: "changes_in_inventory_finishedGoods",
            },
            {
              name: "Employee Benefit Expense",
              key: "employee_benefit_schemes",
            },
            { name: "Other Expenses", key: "otherExpenses" },
            {
              name: "Total Operating Cost",
              key: "total_operating_costs",
              bold: true,
            },
          ],
        },
        {
          items: [
            { name: "Operating Profit ( EBITDA )", key: "operating_profit" },
            { name: "Other Income", key: "other_income" },
            {
              name: "Depreciation and Amortization Expense",
              key: "deprication_amortization_expense",
            },
            { name: "Profit Before Interest and Tax", key: "profit_beforeTax" },
            { name: "Finance Costs", key: "finance_costs" },
            {
              name: "Profit Before Tax and Exceptional Items Before Tax",
              key: "profit_beforeTax_exceptionalItems_beforeTax",
            },
            {
              name: "Exceptional Items Before Tax",
              key: "exceptionalItems_beforeTax",
            },
            { name: "Profit Before Tax", key: "profit_beforeTax" },
            { name: "Income Tax", key: "equity_other_equities" },
            {
              name: "Profit for the Period from Continuing Operations",
              key: "profit_forthePeriod_continuingOperatioins",
            },
            {
              name: "Profit from Discontinuing Operations After Tax",
              key: "profit_discontinuingOperations_afterTax",
            },
            {
              name: "Profit for the Period",
              key: "profit_forthePeriod",
              bold: true,
            },
          ],
        },
      ],
    },
  ];

  const Standalonethree = [
    {
      title: "",
      subcategories: [
        {
          items: [
            { name: "Managerial Remuneration", key: "managerial_renumeration" },
            {
              name: "Payment to Auditors",
              key: "payment_to_auditors",
            },
            { name: "Insurance Expenses", key: "insurance_expenses" },
            { name: "Power and Fuel", key: "power_and_fuel" },
          ],
        },
      ],
    },
  ];

  const Standalonefour = [
    {
      title: "Cash Flows",
      subcategories: [
        {
          subtitle: "Cash Flows from / ( Used in ) Operating Activities",
          items: [
            { name: "Profit Before Tax", key: "profit_beforeTax" },
            {
              name: "Adjustment for Finance Cost and Depreciation",
              key: "adjustments_financeCosts_deprication",
            },
            {
              name: "Adjustments for Current and Non-Current Assets",
              key: "adjustments_current_noncurrent_assets",
            },
            {
              name: "Adjustments for Current and Non-Current Liabilities",
              key: "adjustments_current_noncurrent_liabilities",
            },
            {
              name: "Other Adjustments in Operating Activities",
              key: "adjustments_other_operating_activities",
            },
          ],
        },
        {
          subtitle: "Net Cash Flows from / ( Used in ) Operating Activities",
          items: [
            {
              name: "Net Cash Flows from / ( Used in ) Operating Activities",
              key: "net_cash_flow_operating_activities",
            },
          ],
        },
        {
          subtitle: "Cash Flows from / ( Used in ) Investing Activities",
          items: [
            {
              name: "Cash Outflow from Purchase of Assets",
              key: "cash_outflow_purchase_assets",
            },
            {
              name: "Cash Inflow from Sale of Assets",
              key: "cash_inflow_sale_assets",
            },
            { name: "Income from Assets", key: "income_from_assets" },
            {
              name: "Other Adjustments in Investing Activities",
              key: "other_adjustments_investing_activities",
            },
          ],
        },
        {
          subtitle: "Net Cash Flows from / ( Used in ) Investing Activities",
          items: [
            {
              name: "Net Cash Flows from / ( Used in ) Investing Activities",
              key: "net_cashflow_investing_activities",
            },
          ],
        },
        {
          subtitle: "Cash Flows from / ( Used in ) Financing Activities",
          items: [
            {
              name: "Cash Outflow from Repayment of Capital and Borrowings",
              key: "cash_outflow_repayment_captial_borrowings",
            },
            {
              name: "Cash Inflow from Raising Capital and Borrowings",
              key: "cash_inflow_raising_capital_borrowings",
            },
            {
              name: "Interest and Dividends Paid",
              key: "interest_dividend_paid",
            },
            {
              name: "Other Adjustments in Financing Activities",
              key: "other_adjustments_financing_activities",
            },
            {
              name: "Net Cash Flows from / ( Used in ) Financing Activities",
              key: "net_cashflow_financial_activities",
            },
            {
              name: "Increase / (Decrease) in Cash and Cash Equivalents Before Effect of Exchange Rate Changes",
              key: "increase_or_decrease_cash_exchange_rate_changes",
            },
          ],
        },
        {
          subtitle: "Adjustments to Cash and Cash Equivalents",
          items: [
            {
              name: "Net Increase / (Decrease) in Cash and Cash Equivalents",
              key: "net_increase_decrease_cashequivalents",
            },
            {
              name: "Cash and Cash Equivalents at End of Period",
              key: "cash_and_cashequivalents_endofperiod",
            },
          ],
        },
      ],
    },
  ];

  const Standalonefive = [
    {
      title: "Ratios - AOC-4",
      subcategories: [
        {
          subtitle: "Ratios - AOC-4",
          items: [
            { name: "Revenue Growth (%)", key: "revenue_growth" },
            { name: "Gross Profit Margin (%)", key: "gross_profit_margin" },
            { name: "EBITDA Margin (%)", key: "EBITDA_margin" },
            { name: "Net Margin (%)", key: "net_margin" },
            { name: "Return on Equity (%)", key: "return_on_equity" },
            {
              name: "Return on Capital Employed (%)",
              key: "return_on_capital_employed",
            },
            { name: "Debt Ratio", key: "debt_ratio" },
            { name: "Debt / Equity", key: "debit_ratio" },
            {
              name: "Interest Coverage Ratio",
              key: "interest_coverage_ration",
            },
            { name: "Current Ratio", key: "current_ratio" },
            { name: "Quick Ratio", key: "quick_ratio" },
            { name: "Inventory / Sales (Days)", key: "inventory_days" },
            { name: "Debtors / Sales (Days)", key: "debtor_days" },
            { name: "Payables / Sales (Days)", key: "payables_days" },
            {
              name: "Cash Conversion Cycle (Days)",
              key: "cash_conversion_cycle_days",
            },
            { name: "Sales / Net Fixed Assets", key: "sales_netfixed_assets" },
          ],
        },
      ],
    },
  ];

  const convertValue = (value, monetaryUnit) => {
    console.log("monetaryUnit", monetaryUnit);
    // If no value, return as is
    if (value === undefined || value === null) return value;

    // Parse the monetary unit from API (e.g., "Millions of INR", "Lakhs of INR", "Crores of INR")
    let sourceUnit = "Crore"; // Default to Crore if not specified

    if (monetaryUnit) {
      if (monetaryUnit.includes("Million")) {
        sourceUnit = "Million";
      } else if (monetaryUnit.includes("Lakh")) {
        sourceUnit = "Lakh";
      } else if (monetaryUnit.includes("Crore")) {
        sourceUnit = "Crore";
      }
    }

    // First, convert the value to a common base (INR)
    let valueInINR = value;
    switch (sourceUnit) {
      case "Million":
        valueInINR = value * 10000000; // 1 Million = 10,000,000 INR
        break;
      case "Lakh":
        valueInINR = value * 100000; // 1 Lakh = 100,000 INR
        break;
      case "Crore":
        valueInINR = value * 10000000; // 1 Crore = 10,000,000 INR
        break;
      default:
        valueInINR = value;
    }

    // Then, convert from INR to the target currency selected by user
    let convertedValue;
    switch (currency) {
      case "Lakh":
        convertedValue = valueInINR / 100000;
        break;
      case "Million":
        convertedValue = valueInINR / 10000000;
        break;
      case "INR":
        convertedValue = valueInINR;
        break;
      case "Crore":
      default:
        convertedValue = valueInINR / 10000000;
        break;
    }

    return Number(convertedValue).toFixed(2);
  };

  return (
    <div className={styles.financial_Data_table_subcontainer}>
      <div className={styles.financialdata_currency}>
        <div className={styles.Compilance_header_text}>
          Financial Statements - Standalone
        </div>
        {hasData && (
          <>
            <div className={styles.yearSelectContainer}>
              <select
                className={styles.financialYearselect}
                value={selectedDateRange}
                onChange={(e) => setSelectedDateRange(e.target.value)}
              >
                <option value="" disabled>
                  {" "}
                  Select Year Range
                </option>
                {financialYears
                  .sort((a, b) => parseInt(b) - parseInt(a)) // Sort the years in descending order
                  .map((year, index) => {
                    const startYear = parseInt(year) - 1;
                    const endYear = parseInt(year);
                    const label = `${startYear} - ${endYear}`; // e.g., 2023 - 2024 for financialYear 2024
                    return (
                      <option key={index} value={label}>
                        {label}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className={styles.financialdata_currency_select}>
              <div>
                <FaRupeeSign />
              </div>
              <div>
                <select
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  className="unit-width"
                >
                  <option value="Crore">Crore</option>
                  <option value="Lakh">Lakh</option>
                  <option value="INR">INR</option>
                  <option value="" disabled>
                    --------
                  </option>
                  <option value="Million">Million</option>
                </select>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Standalone Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandaloneOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandalone}>
          {isStandaloneOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>
          Balance Sheet - AOC-4 ( ₹ {currency} )
        </h3>
      </div>

      {isStandaloneOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents(s)</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.referenceDocuments?.MaiinFileName ? (
                    <a
                      href={item?.referenceDocuments?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.referenceDocuments?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.referenceDocuments?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div
            className={styles.scrollWrapper}
            ref={tableRef1}

          >
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Balance Sheet - AOC-4 ( ₹ {currency} )
                  </th>
                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}{" "}
                          {/* Display the full first year */}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}{" "}
                          {/* Display the full second year */}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {/* Loop through BalanceSheet */}
                    {[...BalanceSheet].map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        {/* Loop through subcategories */}
                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            <tr>
                              <td
                                className={styles.financial_scroll_table}
                                id={styles.financial_subtitle}
                              >
                                {subcategory.subtitle}
                              </td>
                              <td></td>
                            </tr>
                            {/* Loop through category items */}
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                                className={styles.financial_scroll_table}
                              >
                                <td
                                  className={`${styles.financial_scroll_table} ${styles?.financial_scroll_table}`}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#000000",
                                  }}
                                >
                                  {category.name}
                                </td>
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financialYear === year.trim()
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value, data?.monetary_unit)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2} style={{textAlign:"center"}}>No Balancesheet available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Standalone Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandaltwoOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandaltwo}>
          {isStandaltwoOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>
          {" "}
          Profit & Loss - AOC-4 ( ₹ {currency} )
        </h3>
      </div>

      {isStandaltwoOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.referenceDocuments?.MaiinFileName ? (
                    <a
                      href={item?.referenceDocuments?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.referenceDocuments?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.referenceDocuments?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div className={styles.scrollWrapper} ref={tableRef2}>
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Profit & Loss - AOC-4 ( ₹ {currency} )
                  </th>

                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}{" "}
                          {/* Display the full first year */}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}{" "}
                          {/* Display the full second year */}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {/* Loop through BalanceSheet */}
                    {sections.map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            // className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          {/* <td></td> */}
                        </tr>

                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                              // className={styles.financial_scroll_table}
                              >
                                <td
                                  // className={`${styles.financial_scroll_table} ${styles?.financial_scroll_table}`}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#030712",
                                  }}
                                >
                                  {category.name}
                                </td>

                                {/* {filteredData.map((data, index) => {
                                  const value = data?.[category.key];
                                  const convertedValue =
                                    value !== undefined && value !== null
                                      ? convertValue(value)
                                      : "0";
                                  return (
                                    <td
                                      key={index}
                                      style={{
                                        color: "#030712",
                                        fontWeight: "800",
                                        width: "30%",
                                      }}
                                    >
                                      {convertedValue}
                                    </td>
                                  );
                                })} */}
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financialYear === year.trim()
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value, data?.monetary_unit)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                          width: "30%",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}

                                {/* <td></td> */}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2} style={{textAlign:"center"}}>No Profit & Loss - AOC-4 data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Standalone Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandalthreeOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandalthree}>
          {isStandalthreeOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>
          {" "}
          Profit & Loss - Key Schedule ( ₹ {currency} )
        </h3>
      </div>

      {isStandalthreeOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.referenceDocuments?.MaiinFileName ? (
                    <a
                      href={item?.referenceDocuments?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.referenceDocuments?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.referenceDocuments?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div className={styles.scrollWrapper} ref={tableRef3}>
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Profit & Loss - AOC-4 ( ₹ {currency} )
                  </th>

                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}{" "}
                          {/* Display the full first year */}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}{" "}
                          {/* Display the full second year */}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {/* Loop through BalanceSheet */}
                    {Standalonethree.map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            // className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          {/* <td></td> */}
                        </tr>

                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                              // className={styles.financial_scroll_table}
                              >
                                <td
                                  // className={`${styles.financial_scroll_table} ${styles?.financial_scroll_table}`}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#030712",
                                  }}
                                >
                                  {category.name}
                                </td>

                                {/* {filteredData.map((data, index) => {
                                  const value = data?.[category.key];
                                  const convertedValue =
                                    value !== undefined && value !== null
                                      ? convertValue(value)
                                      : "0";
                                  return (
                                    <td
                                      key={index}
                                      style={{
                                        color: "#030712",
                                        fontWeight: "800",
                                        width: "30%",
                                      }}
                                    >
                                      {convertedValue}
                                    </td>
                                  );
                                })} */}
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financialYear === year.trim()
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value, data?.monetary_unit)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                          width: "30%",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}

                                {/* <td></td> */}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2}>No   Profit & Loss - Key Schedule  data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Standalonefour Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandalfourOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandalfour}>
          {isStandalfourOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>
          {" "}
          Cash Flow - AOC-4 ( ₹ {currency} ){" "}
        </h3>
      </div>

      {isStandalfourOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.referenceDocuments?.MaiinFileName ? (
                    <a
                      href={item?.referenceDocuments?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.referenceDocuments?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.referenceDocuments?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div
            className={styles.scrollWrapper}
            ref={tableRef4}

          >
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Profit & Loss - AOC-4 ( ₹ {currency} )
                  </th>

                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}{" "}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}{" "}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {[...Standalonefour].map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        {/* Loop through subcategories */}
                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            <tr>
                              <td
                                className={styles.financial_scroll_table}
                                id={styles.financial_subtitle}
                              >
                                {subcategory.subtitle}
                              </td>
                              <td></td>
                            </tr>
                            {/* Loop through category items */}
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                                className={styles.financial_scroll_table}
                              >
                                <td
                                  className={`${styles.financial_scroll_table} ${styles?.financial_scroll_table}`}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#000000",
                                  }}
                                >
                                  {category.name}
                                </td>
                                {/* {filteredData.map((data, index) => {
                                  const value = data?.[category.key];
                                  const convertedValue =
                                    value !== undefined && value !== null
                                      ? convertValue(value)
                                      : "0";
                                  return (
                                    <td
                                      key={index}
                                      style={{
                                        color: "#030712",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {convertedValue}
                                    </td>
                                  );
                                })} */}
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financialYear === year.trim()
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value, data?.monetary_unit)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                          width: "30%",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2} style={{textAlign:"center"}}>No  Profit & Loss - AOC-4  data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {/*Standalonefive*/}

      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandalfiveOpen}
        aria-controls="financial-data-table-five"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandalfive}>
          {isStandalfiveOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>Ratios - AOC-4</h3>
      </div>

      {isStandalfiveOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.referenceDocuments?.MaiinFileName ? (
                    <a
                      href={item?.referenceDocuments?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.referenceDocuments?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.referenceDocuments?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div
            className={styles.scrollWrapper}
            ref={tableRef5}

          >
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Profit & Loss - AOC-4 ( ₹ {currency} )
                  </th>
                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}{" "}
                          {/* Display the full first year */}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}{" "}
                          {/* Display the full second year */}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {/* Loop through BalanceSheet */}
                    {Standalonefive.map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td id={styles.financial_title}>{section.title}</td>
                          <td></td>
                        </tr>

                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            {subcategory.items.map((category, idx) => (
                              <tr key={idx}>
                                <td
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#030712",
                                  }}
                                >
                                  {category.name}
                                </td>

                                {/* {filteredData.map((data, index) => {
                                  const value = data?.[category.key];
                                  return (
                                    <td
                                      key={index}
                                      style={{
                                        color: "#030712",
                                        fontWeight: "800",
                                        width: "30%",
                                      }}
                                    >
                                      {value !== undefined && value !== null
                                        ? value
                                        : "0"}
                                    </td>
                                  );
                                })} */}
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financialYear === year.trim()
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? (value)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                          width: "30%",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2} style={{textAlign:"center"}}>No  Profit & Loss - AOC-4 data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinanialStatmentStandlone;
